exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__App__app__3cSyJ {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  padding: 10px 15px;\n  position: relative;\n}\n\n.dmb-web__App__optionsContainer__1J3P4 {\n  position: absolute;\n  right: 10px;\n  top: 20px;\n  z-index: 2;\n}\n\n.dmb-web__App__segmentController__6zG3T {\n  position: relative;\n}\n\n/* specificity is strong for this one */\ndiv.dmb-web__App__forecastWeatherTab__1VPDH {\n  color: #FFF;\n}\n\n.dmb-web__App__segmentTabIcon__21e1f > svg {\n  position: relative;\n  right: 5px;\n  top: 2px;\n}\n\n.dmb-web__App__pastWeatherPaywall__1TeiL[class^='crate__Modal'] {\n  margin-top: 30dvh;\n}\n", ""]);

// exports
exports.locals = {
	"app": "dmb-web__App__app__3cSyJ",
	"optionsContainer": "dmb-web__App__optionsContainer__1J3P4",
	"segmentController": "dmb-web__App__segmentController__6zG3T",
	"forecastWeatherTab": "dmb-web__App__forecastWeatherTab__1VPDH",
	"segmentTabIcon": "dmb-web__App__segmentTabIcon__21e1f",
	"pastWeatherPaywall": "dmb-web__App__pastWeatherPaywall__1TeiL"
};